import Intranet from "@/layouts/intranet/Index.vue";
import crudUpdate from "@/components/crud_ag/actions/Update";

export default {
  path: "/hour-packs",
  component: Intranet,
  children: [
    {
      path: "",
      name: "hourPacksCrud",
      component: () => import("@/views/crud/PackHorasCrud.vue"),
      meta: {
        auth: true,
        title: "Packs d'hores",
        serviceName: "packs-horas",
      },
      children: [
        {
          path: ":id",
          name: "hourPacksCrudUpdate",
          component: crudUpdate,
          meta: {
            auth: true,
            title: "Pack d'hores",
            serviceName: "packs-horas",
          },
        },
      ],
    },
  ],
};
